import "./CSS/Navbar.css"
import { NavLink, Link, Navigate, useNavigate } from "react-router-dom"
import { useContext, useRef, useEffect } from "react"
import { userContext } from "../App"
import { getAuth, signOut } from "firebase/auth";
import { AiOutlineMenu } from "react-icons/ai";

import { toast } from 'react-toastify';

const inActiveStyle = {listStyle: "none", textDecoration: "none", color: "white"}
const activeStyle = {...inActiveStyle, textDecoration: "underline wheat"}
const stylingFunction = ({isActive}) => {
                        if(isActive) {
                            return activeStyle
                        }
                        return inActiveStyle
                    }

const Navbar = () => {

    const {user, setUser} = useContext(userContext)
    const navigate = useNavigate()

    const refToOptions1 = useRef(null)
    const refToOptions2 = useRef(null)

    useEffect(() => {
        if(window.innerWidth <= 768) {
            refToOptions1.current.style.display = 'none';
            refToOptions2.current.style.display = 'none';
        }
        else {
            refToOptions1.current.style.display = 'block';
            refToOptions2.current.style.display = 'block';
        }
        window.addEventListener('resize', () => {
            if(window.innerWidth <= 768) {
            refToOptions1.current.style.display = 'none';
            refToOptions2.current.style.display = 'none';
        }
        else {
            refToOptions1.current.style.display = 'block';
            refToOptions2.current.style.display = 'block';
        }
        })
    }, [])


    const signOutUser = () => {
        const auth = getAuth();
        signOut(auth).then(() => {  
            toast.success('Logged Out Successfully', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            })
        }).
        catch((error) => {
            // An error happened.
            toast.error(error, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });
        });
    }

    const toggleNavbar = () => {
        if(refToOptions1.current.style.display === '' || refToOptions1.current.style.display === 'block') {
            refToOptions1.current.style.display = "none";
            refToOptions2.current.style.display = "none";
        }
        else {
            refToOptions1.current.style.display = 'block';
            refToOptions2.current.style.display = 'block';
        }
    }

    return (
        <div className="navbar">
            <div className="product-description" style={{zIndex: '3'}}>
                <Link to="/" style={inActiveStyle}>
                    <div className="icon-header">
                        <img src="https://img.icons8.com/officel/30/000000/react.png"/>
                        <h2 className="algo-expert-tag">Algorithms Expert</h2>
                    </div>
                </Link>
                <Link className="tagline" to="/" style={{all: "unset"}}>
                    Ace your technical interviews
                </Link>
            </div>
            <div className="navbar-options" ref={refToOptions1}>
                <ul className="navbar-options-ul">
                    <NavLink to="/content" style={stylingFunction}><li className="navbar-option">Content</li></NavLink>
                    <NavLink to="/purchase" style={stylingFunction}><li className="navbar-option purchase">Purchase</li></NavLink>
                </ul>
            </div>
            <div className="navbar-options single-element" ref={refToOptions2}>
                <ul className="navbar-options-ul">
                    {user === null ? <Link to="/auth" style={inActiveStyle}>
                        <li className="navbar-option purchase" style={{fontSize: '20px', textAlign: 'center', fontWeight: 'bolder'}}>Login</li>
                    </Link>: <NavLink to="/" style={inActiveStyle} onClick={signOutUser}><li className="navbar-option purchase">Logout</li></NavLink>}
                </ul>
            </div>

            <div className="navbar-options navbar-menu-option" onClick={toggleNavbar}>
                <AiOutlineMenu className="navbar-icon"/>   
            </div>
        </div>
    )
}

export default Navbar
